import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { FC, PropsWithChildren } from 'react';
import { useSnackbar } from 'notistack';
import { User } from '@/types/database';

import useAuth from './useAuth';
import PageContainer from '../PageContainer';

interface Props extends PropsWithChildren {
  roles: User['role'][];
}

const PrivateRoute: FC<Props> = ({ roles, children }) => {
  const location = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const { user, loading } = useAuth();

  if (user && !isUserAuthorized(user as User, roles)) {
    enqueueSnackbar('You don\'t have access to this resource', { variant: 'error' });
    return <Navigate to="/" />;
  }

  if (loading) return <PageContainer loading />;

  if (!user) return <Navigate to={`/login?redirect=${location.pathname}`} />;

  return children || <Outlet />;
};
export default PrivateRoute;

const isUserAuthorized = (user: User, roles: User['role'][]) => {
  return roles.indexOf(user?.role as User['role']) >= 0;
};
